{
  "CUSTOM_ROLE": {
    "HEADER": "תפקידים מותאמים אישית",
    "LEARN_MORE": "למד עוד על תפקידים מותאמים אישית",
    "DESCRIPTION": "תפקידים מותאמים אישית הם תפקידים שנוצרים על ידי הבעלים או המנהל של החשבון. ניתן להקצות תפקידים אלה לסוכנים כדי להגדיר את הגישה וההרשאות שלהם בתוך החשבון. ניתן ליצור תפקידים מותאמים אישית עם הרשאות ורמות גישה ספציפיות שיתאימו לדרישות הארגון.",
    "COUNT": "{n} custom role | {n} custom roles",
    "HEADER_BTN_TXT": "הוסף תפקיד מותאם אישית",
    "LOADING": "מאחזר תפקידים מותאמים אישית...",
    "SEARCH_PLACEHOLDER": "Search custom roles...",
    "NO_RESULTS": "No custom roles found matching your search",
    "SEARCH_404": "אין פריטים התואמים לשאילתה זו.",
    "PAYWALL": {
      "TITLE": "שדרג כדי ליצור תפקידים מותאמים אישית",
      "AVAILABLE_ON": "התכונה של תפקיד מותאם אישית זמינה רק בתוכניות Business ו-Enterprise.",
      "UPGRADE_PROMPT": "שדרג את התוכנית שלך כדי לקבל גישה לתכונות מתקדמות כמו ניהול צוות, אוטומציות, תכונות מותאמות אישית ועוד.",
      "UPGRADE_NOW": "שדרג עכשיו",
      "CANCEL_ANYTIME": "תוכל לשנות או לבטל את התוכנית שלך בכל עת"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "התכונה של תפקיד מותאם אישית זמינה רק בתוכניות בתשלום.",
      "UPGRADE_PROMPT": "שדרג לתוכנית בתשלום כדי לגשת לתכונות מתקדמות כמו יומני ביקורת, קיבולת סוכנים ועוד.",
      "ASK_ADMIN": "אנא פנה למנהל המערכת שלך לצורך השדרוג."
    },
    "LIST": {
      "404": "אין תפקידים מותאמים אישית זמינים בחשבון זה.",
      "TITLE": "נהל תפקידים מותאמים אישית",
      "DESC": "תפקידים מותאמים אישית הם תפקידים שנוצרים על ידי הבעלים או המנהל של החשבון. ניתן להקצות תפקידים אלה לסוכנים כדי להגדיר את הגישה וההרשאות שלהם בתוך החשבון. ניתן ליצור תפקידים מותאמים אישית עם הרשאות ורמות גישה ספציפיות שיתאימו לדרישות הארגון.",
      "TABLE_HEADER": {
        "NAME": "שם",
        "DESCRIPTION": "תיאור",
        "PERMISSIONS": "הרשאות",
        "ACTIONS": "פעולות"
      }
    },
    "PERMISSIONS": {
      "CONVERSATION_MANAGE": "נהל את כל השיחות",
      "CONVERSATION_UNASSIGNED_MANAGE": "נהל שיחות לא משויכות ואת אלה שמשויכות אליהם",
      "CONVERSATION_PARTICIPATING_MANAGE": "נהל שיחות שבהן הם משתתפים ואת אלה שמשויכות אליהם",
      "CONTACT_MANAGE": "נהל אנשי קשר",
      "REPORT_MANAGE": "נהל דוחות",
      "KNOWLEDGE_BASE_MANAGE": "נהל בסיס ידע"
    },
    "FORM": {
      "NAME": {
        "LABEL": "שם",
        "PLACEHOLDER": "אנא הזן שם.",
        "ERROR": "שם שדה חובה."
      },
      "DESCRIPTION": {
        "LABEL": "תיאור",
        "PLACEHOLDER": "אנא הזן תיאור.",
        "ERROR": "נדרש תיאור."
      },
      "PERMISSIONS": {
        "LABEL": "הרשאות",
        "ERROR": "הרשאות נדרשות."
      },
      "CANCEL_BUTTON_TEXT": "ביטול",
      "API": {
        "ERROR_MESSAGE": "לא ניתן להתחבר לשרת Woot, נסה שוב מאוחר יותר"
      }
    },
    "ADD": {
      "TITLE": "הוסף תפקיד מותאם אישית",
      "DESC": "תפקידים מותאמים אישית מאפשרים לך ליצור תפקידים עם הרשאות ורמות גישה ספציפיות שיתאימו לדרישות הארגון.",
      "SUBMIT": "שלח",
      "API": {
        "SUCCESS_MESSAGE": "תפקיד מותאם אישית נוסף בהצלחה."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "ערוך",
      "TITLE": "ערוך תפקיד מותאם אישית",
      "DESC": "תפקידים מותאמים אישית מאפשרים לך ליצור תפקידים עם הרשאות ורמות גישה ספציפיות שיתאימו לדרישות הארגון.",
      "SUBMIT": "עדכן",
      "API": {
        "SUCCESS_MESSAGE": "התפקיד המותאם אישית עודכן בהצלחה."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "מחק",
      "API": {
        "SUCCESS_MESSAGE": "התפקיד המותאם אישית נמחק בהצלחה.",
        "ERROR_MESSAGE": "לא ניתן להתחבר לשרת Woot, נסה שוב מאוחר יותר"
      },
      "CONFIRM": {
        "TITLE": "אשר מחיקה",
        "MESSAGE": "האם אתה בטוח שברצונך למחוק ",
        "YES": "כן, מחק ",
        "NO": "לא, השאר "
      }
    }
  }
}
